import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';
import { Link } from 'components/link';

export const Root = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    &:not(:first-of-type) {
      margin-top: ${theme.spacing(6)};
    }
  `}

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    &:not(:first-of-type) {
      margin-top: ${theme.spacing(4)};
    }
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => `
    border: 1px solid ${theme.colors.neutrals.grey8};
    padding: ${theme.spacing(4)} ${theme.spacing(3)};
    border-radius: ${theme.borderRadius.small};
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    padding: ${theme.spacing(3)} ${theme.spacing(2)};
  `}
`;

export const Header = styled(H3)`
  ${({ theme }) => `
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const DeveloperInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const DescriptionWrapper = styled.div<{ isModeB?: boolean }>`
  ${({ theme, isModeB }) => `
    margin-top: ${theme.spacing(3)};
    ${isModeB ? 'max-width: 740px;' : ''}
  `}
`;

export const DeveloperLinkText = styled(Text)`
  display: flex;
  align-items: center;
`;

export const StyledLink = styled(Link)`
  ${({ theme }) => `
    color: ${theme.colors.brand.main};
    text-decoration: none;
  `}
`;

export const DevelopersWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(6)};
  `}
`;

export const DeveloperLogo = styled.div<{ size?: number; noSideMargin?: boolean; isSquare?: boolean; developerLogo?: string; }>`
  ${({ theme, size = 64, noSideMargin }) => `
    margin-left: ${noSideMargin ? 0 : theme.spacing(3)};
    height: ${size}px;
    width: ${size}px;
    border-radius: ${theme.borderRadius.tiny};
    padding: ${theme.spacing(0.5)};
    background: ${theme.colors.neutrals.white};
    box-shadow: ${theme.shadow.level2};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: block;
      object-fit: contain;
      max-width: 100%;
      height: 100%;
      margin: 0 auto;
    }
  `}
  ${({ theme, noSideMargin }) => theme.media.showAt({ at: 1 }) `
    margin-left: ${noSideMargin ? 0 : theme.spacing(2)};
  `}
  ${({ theme, isSquare, developerLogo }) => isSquare && !developerLogo && `
    & svg {
      border-radius: ${theme.borderRadius.micro};
      overflow: hidden;
    }
  `}
`;
